import app from 'flarum/common/app';
import { KeyValueGambit } from 'flarum/common/query/IGambit';
export default class StatusGambit extends KeyValueGambit {
  key() {
    return app.translator.trans('neverhack-forum-nodes.lib.gambits.discussions.status.key', {}, true);
  }
  hint() {
    return app.translator.trans('neverhack-forum-nodes.lib.gambits.discussions.status.hint', {}, true);
  }
  filterKey() {
    return 'status';
  }
}
flarum.reg.add('neverhack-forum-nodes', 'common/query/discussions/StatusGambit', StatusGambit);